import { anchorLink } from "../include/module";
(() => { anchorLink(); })();

import { lowSlider } from "../include/module";
(() => { lowSlider(); })();

import { headerResize } from "../include/module";
(() => { headerResize(); })();

import { studioHover } from "../include/module";
(() => { studioHover(); })();

import { toggleMenu } from "../include/module";
(() => { toggleMenu(); })();



// WEBPACK FOOTER //
// ./src/assets/js/studio/script.js